import filterData from '../data/inboundFilterData.json';
import { localStationTimeToEpochMs } from '../utils/dataTransformer';

export const InboundFilterReducer = (state, action) => {
    switch (action.type) {
        case 'LOAD_FILTER_DATA':
            return {
                ...state,
                allTimeRanges: filterData.timeRanges,
                selectedTimeRange: '6hours',
                customStartDate: '',
                customStartTime: '',
                customEndDate: '',
                customEndTime: '',
                useCustomTimeRange: false,
                useShiftEndMode: false,
                timeRangeMode: 'relative',
                customTimeRangeError: '',
                triggerFetch: Date.now()
            };

        case 'SELECT_TIME_RANGE':
            return {
                ...state,
                selectedTimeRange: action.timeRange,
                useCustomTimeRange: false,
                useShiftEndMode: false,
                customStartDate: '',
                customStartTime: '',
                customEndDate: '',
                customEndTime: '',
                customTimeRangeError: '',
                triggerFetch: Date.now()
            };

        case 'SET_TIME_RANGE_MODE':
            if (action.mode === 'relative') {
                return {
                    ...state,
                    timeRangeMode: 'relative',
                    useCustomTimeRange: false,
                    useShiftEndMode: false,
                    customStartDate: '',
                    customStartTime: '',
                    customEndDate: '',
                    customEndTime: '',
                    customTimeRangeError: '',
                    selectedTimeRange: state.selectedTimeRange || '6hours',
                    triggerFetch: Date.now()
                };
            }
            return {
                ...state,
                timeRangeMode: 'custom',
                selectedTimeRange: '',
                useCustomTimeRange: false,
                useShiftEndMode: false,
                customTimeRangeError: ''
            };

        case 'SET_CUSTOM_START_DATE': {
            const s = { ...state, customStartDate: action.date, customTimeRangeError: '' };
            if (state.selectedTimeRange !== '') s.selectedTimeRange = '';
            return s;
        }

        case 'SET_CUSTOM_START_TIME': {
            const s = { ...state, customStartTime: action.time, customTimeRangeError: '' };
            if (state.selectedTimeRange !== '') s.selectedTimeRange = '';
            return s;
        }

        case 'SET_CUSTOM_END_DATE': {
            const s = { ...state, customEndDate: action.date, customTimeRangeError: '' };
            if (state.selectedTimeRange !== '') s.selectedTimeRange = '';
            return s;
        }

        case 'SET_CUSTOM_END_TIME': {
            const s = { ...state, customEndTime: action.time, customTimeRangeError: '' };
            if (state.selectedTimeRange !== '') s.selectedTimeRange = '';
            return s;
        }

        case 'SET_STATION_TIMEZONE':
            return { ...state, stationTimezone: action.stationTimezone };

        case 'APPLY_CUSTOM_TIME_RANGE': {
            const startMs = localStationTimeToEpochMs(
                state.customStartDate, state.customStartTime, state.stationTimezone);
            const endMs = localStationTimeToEpochMs(
                state.customEndDate, state.customEndTime, state.stationTimezone);
            const nowMs = Date.now();
            const hoursDiff = (endMs - startMs) / (1000 * 60 * 60);
            const endIsFuture = endMs > nowMs;

            if (startMs > nowMs) {
                return { ...state, customTimeRangeError: 'Start date and time cannot be in the future' };
            } else if (hoursDiff <= 0 || hoursDiff < (1 / 60)) {
                return { ...state, customTimeRangeError: 'End time must be after start time' };
            } else if (hoursDiff > 12) {
                return { ...state, customTimeRangeError: 'Time range cannot exceed 12 hours' };
            }

            return {
                ...state,
                customTimeRangeError: '',
                useCustomTimeRange: true,
                useShiftEndMode: endIsFuture,
                triggerFetch: Date.now()
            };
        }

        case 'CLEAR_TIME_RANGE':
            return {
                ...state,
                selectedTimeRange: '',
                customStartDate: '',
                customStartTime: '',
                customEndDate: '',
                customEndTime: '',
                useCustomTimeRange: false,
                useShiftEndMode: false,
                timeRangeMode: 'relative',
                customTimeRangeError: ''
            };

        case 'CLEAR_ALL_FILTERS':
            return {
                ...state,
                selectedTimeRange: '',
                customStartDate: '',
                customStartTime: '',
                customEndDate: '',
                customEndTime: '',
                useCustomTimeRange: false,
                useShiftEndMode: false,
                timeRangeMode: 'relative',
                customTimeRangeError: ''
            };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/components/inbound/reducers/InboundFilterReducer.js